// 全局登录用户变量上报
import { gioVisitorTrack } from './index';

/**
 * abtest用户变量
 */

export const setGioVisitorForABTest = (abtest = {}) => {
    try {
        const keys = [
            //充值金卡入口
            'GcCzfirstAb',
        ];
        const ab = Object.entries(abtest).reduce((o, [key, i]) => {
            o[key] = i.abTest;
            return o;
        }, {});
        const data = keys.reduce((result, key) => {
            result[`${key}_ppl`] = `${ab[key] || 'A'}版`;
            return result;
        }, {});
        gioVisitorTrack(data);
    } catch (e) {
        window.monitor &&
            window.monitor.report({
                level: 'info',
                url: location.href,
                error: 'setVisitor',
                msg: 'setVisitor error',
                stack: e.stack,
            });
    }
};
